import { uniqBy } from "lodash";
import { handleActions } from "redux-actions";

import { updateById } from "utils";
import { fullName } from "utils/user";

const withFullName = (contact) => ({
  ...contact,
  name: fullName(contact),
});

const contactReducer = handleActions(
  {
    ASSET_LEAD_CONTACTS_GET: {
      FULFILLED: ({ assetLeadContacts }, { payload }) => ({
        assetLeadContacts: uniqBy(
          [...assetLeadContacts, ...payload.contacts.map(withFullName)],
          "id"
        ),
      }),
    },

    ASSET_LEAD_CONTACT_UPDATE: {
      FULFILLED: ({ assetLeadContacts }, { payload }) => ({
        assetLeadContacts: updateById(assetLeadContacts, withFullName(payload.contact)),
      }),
    },

    ASSET_LEAD_CONTACT_CREATE: {
      FULFILLED: ({ assetLeadContacts, currentUser, posts }, { payload: { contact } }) => ({
        assetLeadContacts: [...assetLeadContacts, withFullName(contact)],
        posts: [
          {
            meta: { after: contact.company || fullName(contact) },
            body: "asset_lead_add_contact",
            creator: currentUser,
            type: "SystemEvent",
          },
          ...posts,
        ],
      }),
    },

    ASSET_LEAD_CONTACT_DELETE: {
      FULFILLED: ({ assetLeadContacts }, { meta: { contactID } }) => ({
        assetLeadContacts: assetLeadContacts.filter((contact) => contact.id !== contactID),
      }),
    },
  },
  {},
  { namespace: "_" }
);

export default contactReducer;
